import {
  Users,
  UserPlus,
  FolderPlus,
  FilePlus,
  LayoutGrid,
  Inbox,
  Tag,
  DollarSign,
  CheckSquare,
  Wallet,
  CreditCard,
  Receipt,
  Building2,
} from "lucide-react";
import { isFreelance, isProjectManager } from "./constants/accountType";

export const quickActionsFor = (user) => {
  if (!user) return null;

  if (user.roleSlug === "administrator" && !user.setup_completed) return null;

  if (user.roleSlug === "vendor") return null;

  if (user.roleSlug === "vendor_manager") {
    return {
      label: "Quick actions",
      actions: [
        { to: "/vendors/create-vendor", icon: UserPlus,   label: "New vendor" },
        { to: "/vendor/applications",   icon: Inbox,      label: "Applications" },
        { to: "/vendor/contacts",       icon: Users,      label: "Contacts" },
        { to: "/vendor/prices",         icon: DollarSign, label: "Prices" },
        { to: "/vendor/tags",           icon: Tag,        label: "Tags" },
        { to: "/todos",                 icon: CheckSquare, label: "To dos" },
      ],
    };
  }  

  if (user.roleSlug === "account_manager") {
    return {
      label: "Go to",
      actions: [
        { to: "/clients",            icon: Users,      label: "Clients" },
        { to: "/vendors",            icon: Building2,  label: "Vendors" },
        { to: "/client/receivables", icon: Wallet,     label: "Receivables" },
        { to: "/vendor/payables",    icon: CreditCard, label: "Payables" },
        { to: "/client/payments",    icon: Receipt,    label: "Client payments" },
        { to: "/vendor/payments",    icon: Receipt,    label: "Vendor payments" },
      ],
    };
  }

  const freelance = isFreelance(user);
  const projectManager = isProjectManager(user);

  return {
    label: "Quick actions",
    actions: [
      { to: "/projects/create-project", icon: FolderPlus, label: "New project" },
      { to: "/quotations/create-quotation", icon: FilePlus, label: "New quotation" },
      { to: "/clients/create-client",   icon: UserPlus,   label: "Add client" },
      ...(freelance || projectManager
        ? []
        : [
            { to: "/vendors/create-vendor",   icon: UserPlus, label: "Add vendor" },
            { to: "/managers/create-manager", icon: Users,    label: "Add manager" },
          ]),
      ...(projectManager ? [{ to: "/vendors", icon: Users, label: "Vendors" }] : []),
      { to: "/system-values", icon: LayoutGrid, label: "System values" },
    ],
  };
};